var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { getGlobalState } from './GlobalState';
import fetchRecaptchaToken from './FetchRecaptchaToken';
export default function createTicket(email, name, subject, content) {
    return __awaiter(this, void 0, void 0, function* () {
        const applicationUrl = getGlobalState('application_url');
        const token = yield fetchRecaptchaToken();
        try {
            yield axios.post(`${applicationUrl}/api/user/create-ticket`, { email, name, subject, content, token });
        }
        catch (error) {
            return false;
        }
        return true;
    });
}
